// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-box::-webkit-scrollbar {
  display: none;
}
.chat-box .chat-date {
  position: relative;
  width: 100%;
  height: 1px;
  display: block;
  background: var(--chat-date);
  margin: 50px 0;
}
.chat-box .chat-date::after {
  content: attr(data-date);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90px;
  height: 30px;
  background: var(--curier-sms-bg);
  border-radius: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.5px;
  color: var(--ingrediend-text);
}
.chat-box .sms-box {
  padding: 10px 15px 30px 15px;
}
.chat-box .sms-box .admin-message-wrapper {
  display: flex;
  justify-content: flex-end;
}
.chat-box .sms-box .admin-message {
  position: relative;
  background: var(--menubg);
  border-radius: 10px 10px 0 10px;
}
.chat-box .sms-box .admin-message .double-check {
  position: absolute;
  bottom: 0;
  right: 4px;
}
.chat-box .sms-box .admin-message .time {
  right: 0;
}
.chat-box .sms-box .user-message {
  background: var(--curier-sms-bg);
  border-radius: 10px 10px 10px 0;
}
.chat-box .sms-box .user-message .time {
  left: 0;
}
.chat-box .sms-box .admin-message,
.chat-box .sms-box .user-message {
  position: relative;
  width: max-content;
  max-width: 256px;
  padding: 15px 20px;
  margin-top: 35px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.5px;
  color: var(--primary-text);
  word-wrap: break-word;
}
.chat-box .sms-box .admin-message.chat-image,
.chat-box .sms-box .user-message.chat-image {
  padding: 0;
  overflow: hidden;
  height: 100%;
}
.chat-box .sms-box .admin-message.chat-image section,
.chat-box .sms-box .user-message.chat-image section {
  margin-top: 0;
}
.chat-box .sms-box .admin-message.chat-image .text,
.chat-box .sms-box .user-message.chat-image .text {
  padding: 12px 15px;
}
[data-theme=dark] .chat-box .sms-box .admin-message.chat-image,
[data-theme=dark] .chat-box .sms-box .user-message.chat-image {
  padding: 0;
  overflow: hidden;
  height: 100%;
}
[data-theme=dark] .chat-box .sms-box .admin-message.chat-image section,
[data-theme=dark] .chat-box .sms-box .user-message.chat-image section {
  margin-top: 0;
}
[data-theme=dark] .chat-box .sms-box .admin-message.chat-image .text,
[data-theme=dark] .chat-box .sms-box .user-message.chat-image .text {
  padding: 12px 15px;
}
.chat-box .sms-box .admin-message .text,
.chat-box .sms-box .user-message .text {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
}
.chat-box .sms-box .time {
  margin-top: 4px;
  position: absolute;
  top: 100%;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: -0.5px;
  color: var(--ingrediend-text);
}
@media (max-width: 768px) {
  .chat-box .sms-box {
    margin-bottom: 100px;
  }
}
.chat-box .sms-input {
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  bottom: 0;
  width: 400px;
  padding: 20px 35px;
  min-height: 77px;
  background: var(--user-sms-bg);
  box-shadow: 0 1px 2px rgba(169, 169, 150, 0.13);
}
.chat-box .sms-input textarea {
  width: 85%;
  border: none;
  outline: none;
  background: transparent;
  color: var(--primary-text);
}
.chat-box .sms-input textarea::placeholder {
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: var(--ingrediend-text);
}
.chat-box .sms-input .send-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 37px;
  height: 37px;
  background: #45a524;
}
@media (max-width: 768px) {
  .chat-box .sms-input {
    width: 100%;
  }
}

.chat-container {
  border: 1px solid var(--border-color);
}
.chat-container * {
  font-family: "Inter", sans-serif !important;
}
.chat-container .chat-sidebar {
  border-color: var(--border-color) !important;
}
.chat-container .chat-container {
  border-color: var(--border-color) !important;
}
.chat-container .chat-container .chat-header {
  border-color: var(--border-color) !important;
  background-color: var(--grey);
}
.chat-container .chat-container .chat-header .cs-conversation-header__user-name {
  background-color: var(--grey);
}
.chat-container .chat-container .chat-input {
  border-color: var(--border-color);
}
.chat-container .chat-container .chat-input .cs-button {
  color: var(--primary);
}
.chat-container .chat-container .chat-input .cs-message-input__content-editor-wrapper {
  background-color: var(--menubg);
}
.chat-container .chat-container .chat-input .cs-message-input__content-editor-wrapper div {
  background-color: var(--menubg);
}

.more-btn {
  color: var(--primary);
  cursor: pointer;
}

[data-theme=dark] .chat-container {
  background-color: var(--dark-background);
  border-color: var(--dark-grey) !important;
}
[data-theme=dark] .chat-container .cs-sidebar--left {
  background-color: var(--dark-background);
}
[data-theme=dark] .chat-container .cs-conversation-list,
[data-theme=dark] .chat-container .cs-conversation,
[data-theme=dark] .chat-container .cs-conversation__name {
  color: var(--light-text);
  background-color: transparent !important;
}
[data-theme=dark] .chat-container .cs-conversation__info {
  color: var(--dark-muted-text);
}
[data-theme=dark] .chat-container .cs-conversation:hover {
  background-color: var(--dark-primary-hover);
}
[data-theme=dark] .chat-container .cs-message-list {
  background-color: var(--dark-background);
  color: var(--light-text);
}
[data-theme=dark] .chat-container .chat-sidebar {
  border-color: var(--dark-grey) !important;
}
[data-theme=dark] .chat-container .chat-header {
  background-color: var(--dark-background);
  border-color: var(--dark-grey) !important;
}
[data-theme=dark] .chat-container .chat-header .cs-conversation-header__user-name {
  background-color: transparent;
  color: var(--light-text);
}
[data-theme=dark] .chat-container .chat-input {
  border-color: var(--dark-grey) !important;
}
[data-theme=dark] .chat-container .cs-message-input {
  background-color: var(--dark-background);
  color: var(--light-text);
}
[data-theme=dark] .chat-container .cs-message-input__content-editor-wrapper {
  background-color: rgb(40, 49, 66) !important;
  border: 1px solid var(--dark-grey);
}
[data-theme=dark] .chat-container .cs-message-input__content-editor-wrapper div {
  background-color: rgb(40, 49, 66) !important;
}
[data-theme=dark] .chat-container .cs-message-input__content-editor {
  color: var(--dark-text-muted);
}
[data-theme=dark] .chat-container .cs-message-input__content-editor[data-placeholder]:empty:before {
  color: var(--light-text);
}
[data-theme=dark] .chat-container .chat-box .sms-box .admin-message,
[data-theme=dark] .chat-container .chat-box .sms-box .user-message {
  background: var(--dark-primary-hover);
  color: var(--light-text);
}
[data-theme=dark] .chat-container .chat-box .sms-box .admin-message .time,
[data-theme=dark] .chat-container .chat-box .sms-box .user-message .time {
  color: var(--dark-muted-text);
}
[data-theme=dark] .chat-container .chat-box .chat-date {
  background: var(--dark-grey);
}
[data-theme=dark] .chat-container .chat-box .chat-date::after {
  background: var(--dark-grey);
  color: var(--light-text);
}

.cs-message__content {
  background: transparent !important;
  padding: 0 !important;
}
.cs-message__content .cs-message__image-content {
  padding: 15px !important;
}

.message-actions-wrapper {
  background-color: var(--white);
  position: sticky;
  display: flex;
  bottom: 0;
  padding-left: 1rem;
  box-shadow: 0 10px 0 0 var(--background);
  -webkit-box-shadow: 0 10px 0 0 var(--background);
  -moz-box-shadow: 0 10px 0 0 var(--background);
}
.message-actions-wrapper::before {
  content: "";
  position: absolute;
  display: block;
  background: var(--primary);
  height: 100%;
  width: 2px;
  left: 0;
}
.message-actions__content {
  flex-grow: 1;
  width: 90%;
}
.message-actions__type {
  font-size: 13px;
  text-transform: capitalize;
}
.message-actions__message {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
}
.message-actions__close-btn {
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}
.message-actions__image {
  max-width: 90%;
  height: 4rem;
  display: block;
}

[data-theme=dark] .message-actions-wrapper {
  background-color: var(--dark-background);
  color: var(--light-text);
  box-shadow: 0 10px 0 0 var(--dark-background);
  -webkit-box-shadow: 0 10px 0 0 var(--dark-background);
  -moz-box-shadow: 0 10px 0 0 var(--dark-background);
}

.reply-message {
  position: relative;
  padding-left: 0.5rem;
  margin-bottom: 0.5rem;
}
.reply-message::after {
  content: "";
  display: block;
  position: absolute;
  height: 100%;
  width: 2px;
  background: var(--primary);
  top: 0;
  left: 0;
}
.reply-message__text {
  font-size: 12px;
  line-height: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reply-message__image {
  display: block;
  max-height: 3rem;
  max-width: 100%;
}

.upload-form {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.upload-form img {
  width: 100%;
  max-height: 270px;
  object-fit: contain;
}
.upload-form textarea {
  margin-top: 20px;
}
.upload-form .footer-btns {
  padding-top: 20px;
  width: 100%;
  gap: 8px;
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/page/chat.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,4BAAA;EACA,cAAA;AADJ;AAGI;EACE,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BAAA;AADN;AAKE;EACE,4BAAA;AAHJ;AAKI;EACE,aAAA;EACA,yBAAA;AAHN;AAMI;EACE,kBAAA;EACA,yBAAA;EACA,+BAAA;AAJN;AAMM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAJR;AAOM;EACE,QAAA;AALR;AASI;EACE,gCAAA;EACA,+BAAA;AAPN;AASM;EACE,OAAA;AAPR;AAWI;;EAEE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,qBAAA;AATN;AAWM;;EACE,UAAA;EACA,gBAAA;EACA,YAAA;AARR;AAUQ;;EACE,aAAA;AAPV;AAUQ;;EACE,kBAAA;AAPV;AAWM;;EACE,UAAA;EACA,gBAAA;EACA,YAAA;AARR;AAUQ;;EACE,aAAA;AAPV;AAUQ;;EACE,kBAAA;AAPV;AAWM;;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AARR;AAYI;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BAAA;AAVN;AAaI;EA7FF;IA8FI,oBAAA;EAVJ;AACF;AAaE;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,+CAAA;AAXJ;AAaI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;AAXN;AAaM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AAXR;AAeI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAbN;AAgBI;EArCF;IAsCI,WAAA;EAbJ;AACF;;AAiBA;EACE,qCAAA;AAdF;AAgBE;EACE,2CAAA;AAdJ;AAiBE;EACE,4CAAA;AAfJ;AAkBE;EACE,4CAAA;AAhBJ;AAkBI;EACE,4CAAA;EACA,6BAAA;AAhBN;AAkBM;EACE,6BAAA;AAhBR;AAoBI;EACE,iCAAA;AAlBN;AAoBM;EACE,qBAAA;AAlBR;AAqBM;EACE,+BAAA;AAnBR;AAqBQ;EACE,+BAAA;AAnBV;;AA0BA;EACE,qBAAA;EACA,eAAA;AAvBF;;AA0BA;EACE,wCAAA;EACA,yCAAA;AAvBF;AAyBE;EACE,wCAAA;AAvBJ;AA0BE;;;EAGE,wBAAA;EACA,wCAAA;AAxBJ;AA2BE;EACE,6BAAA;AAzBJ;AA4BE;EACE,2CAAA;AA1BJ;AA6BE;EACE,wCAAA;EACA,wBAAA;AA3BJ;AA8BE;EACE,yCAAA;AA5BJ;AA+BE;EACE,wCAAA;EACA,yCAAA;AA7BJ;AA+BI;EACE,6BAAA;EACA,wBAAA;AA7BN;AAiCE;EACE,yCAAA;AA/BJ;AAkCE;EACE,wCAAA;EACA,wBAAA;AAhCJ;AAmCE;EACE,4CAAA;EACA,kCAAA;AAjCJ;AAoCE;EACE,4CAAA;AAlCJ;AAqCE;EACE,6BAAA;AAnCJ;AAsCE;EACE,wBAAA;AApCJ;AAuCE;;EAEE,qCAAA;EACA,wBAAA;AArCJ;AAuCI;;EACE,6BAAA;AApCN;AAwCE;EACE,4BAAA;AAtCJ;AAwCI;EACE,4BAAA;EACA,wBAAA;AAtCN;;AA2CA;EACE,kCAAA;EACA,qBAAA;AAxCF;AAyCE;EACE,wBAAA;AAvCJ;;AA4CE;EACE,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,wCAAA;EACA,gDAAA;EACA,6CAAA;AAzCJ;AA2CI;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;AAzCN;AA6CE;EACE,YAAA;EACA,UAAA;AA3CJ;AA8CE;EACE,eAAA;EACA,0BAAA;AA5CJ;AA+CE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AA7CJ;AAgDE;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AA9CJ;AAiDE;EACE,cAAA;EACA,YAAA;EACA,cAAA;AA/CJ;;AAoDE;EACE,wCAAA;EACA,wBAAA;EACA,6CAAA;EACA,qDAAA;EACA,kDAAA;AAjDJ;;AAqDA;EACE,kBAAA;EACA,oBAAA;EACA,qBAAA;AAlDF;AAoDE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,0BAAA;EACA,MAAA;EACA,OAAA;AAlDJ;AAqDE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAnDJ;AAsDE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AApDJ;;AAwDA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AArDF;AAuDE;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AArDJ;AAwDE;EACE,gBAAA;AAtDJ;AAyDE;EACE,iBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AAvDJ","sourcesContent":[".chat-box {\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  .chat-date {\n    position: relative;\n    width: 100%;\n    height: 1px;\n    display: block;\n    background: var(--chat-date);\n    margin: 50px 0;\n\n    &::after {\n      content: attr(data-date);\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      width: 90px;\n      height: 30px;\n      background: var(--curier-sms-bg);\n      border-radius: 57px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 15px;\n      letter-spacing: -0.5px;\n      color: var(--ingrediend-text);\n    }\n  }\n\n  .sms-box {\n    padding: 10px 15px 30px 15px;\n\n    .admin-message-wrapper {\n      display: flex;\n      justify-content: flex-end;\n    }\n\n    .admin-message {\n      position: relative;\n      background: var(--menubg);\n      border-radius: 10px 10px 0 10px;\n\n      .double-check {\n        position: absolute;\n        bottom: 0;\n        right: 4px;\n      }\n\n      .time {\n        right: 0;\n      }\n    }\n\n    .user-message {\n      background: var(--curier-sms-bg);\n      border-radius: 10px 10px 10px 0;\n\n      .time {\n        left: 0;\n      }\n    }\n\n    .admin-message,\n    .user-message {\n      position: relative;\n      width: max-content;\n      max-width: 256px;\n      padding: 15px 20px;\n      margin-top: 35px;\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 19px;\n      letter-spacing: -0.5px;\n      color: var(--primary-text);\n      word-wrap: break-word;\n\n      &.chat-image {\n        padding: 0;\n        overflow: hidden;\n        height: 100%;\n        // background: #f0f2f5 !important;\n        section {\n          margin-top: 0;\n        }\n\n        .text {\n          padding: 12px 15px;\n        }\n      }\n\n      [data-theme='dark'] &.chat-image {\n        padding: 0;\n        overflow: hidden;\n        height: 100%;\n        // background: #293a57 !important;\n        section {\n          margin-top: 0;\n        }\n\n        .text {\n          padding: 12px 15px;\n        }\n      }\n\n      .text {\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 16px;\n      }\n    }\n\n    .time {\n      margin-top: 4px;\n      position: absolute;\n      top: 100%;\n      font-weight: 500;\n      font-size: 10px;\n      line-height: 12px;\n      letter-spacing: -0.5px;\n      color: var(--ingrediend-text);\n    }\n\n    @media (max-width: 768px) {\n      margin-bottom: 100px;\n    }\n  }\n\n  .sms-input {\n    position: fixed;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    bottom: 0;\n    width: 400px;\n    padding: 20px 35px;\n    min-height: 77px;\n    background: var(--user-sms-bg);\n    box-shadow: 0 1px 2px rgba(169, 169, 150, 0.13);\n\n    textarea {\n      width: 85%;\n      border: none;\n      outline: none;\n      background: transparent;\n      color: var(--primary-text);\n\n      &::placeholder {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 15px;\n        color: var(--ingrediend-text);\n      }\n    }\n\n    .send-btn {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 50%;\n      width: 37px;\n      height: 37px;\n      background: #45a524;\n    }\n\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n}\n\n.chat-container {\n  border: 1px solid var(--border-color);\n\n  * {\n    font-family: 'Inter', sans-serif !important;\n  }\n\n  .chat-sidebar {\n    border-color: var(--border-color) !important;\n  }\n\n  .chat-container {\n    border-color: var(--border-color) !important;\n\n    .chat-header {\n      border-color: var(--border-color) !important;\n      background-color: var(--grey);\n\n      .cs-conversation-header__user-name {\n        background-color: var(--grey);\n      }\n    }\n\n    .chat-input {\n      border-color: var(--border-color);\n\n      .cs-button {\n        color: var(--primary);\n      }\n\n      .cs-message-input__content-editor-wrapper {\n        background-color: var(--menubg);\n\n        div {\n          background-color: var(--menubg);\n        }\n      }\n    }\n  }\n}\n\n.more-btn {\n  color: var(--primary);\n  cursor: pointer;\n}\n\n[data-theme='dark'] .chat-container {\n  background-color: var(--dark-background);\n  border-color: var(--dark-grey) !important;\n\n  .cs-sidebar--left {\n    background-color: var(--dark-background);\n  }\n\n  .cs-conversation-list,\n  .cs-conversation,\n  .cs-conversation__name {\n    color: var(--light-text);\n    background-color: transparent !important;\n  }\n\n  .cs-conversation__info {\n    color: var(--dark-muted-text);\n  }\n\n  .cs-conversation:hover {\n    background-color: var(--dark-primary-hover);\n  }\n\n  .cs-message-list {\n    background-color: var(--dark-background);\n    color: var(--light-text);\n  }\n\n  .chat-sidebar {\n    border-color: var(--dark-grey) !important;\n  }\n\n  .chat-header {\n    background-color: var(--dark-background);\n    border-color: var(--dark-grey) !important;\n\n    .cs-conversation-header__user-name {\n      background-color: transparent;\n      color: var(--light-text);\n    }\n  }\n\n  .chat-input {\n    border-color: var(--dark-grey) !important;\n  }\n\n  .cs-message-input {\n    background-color: var(--dark-background);\n    color: var(--light-text);\n  }\n\n  .cs-message-input__content-editor-wrapper {\n    background-color: rgb(40, 49, 66) !important;\n    border: 1px solid var(--dark-grey);\n  }\n\n  .cs-message-input__content-editor-wrapper div {\n    background-color: rgb(40, 49, 66) !important;\n  }\n\n  .cs-message-input__content-editor {\n    color: var(--dark-text-muted);\n  }\n\n  .cs-message-input__content-editor[data-placeholder]:empty:before {\n    color: var(--light-text);\n  }\n\n  .chat-box .sms-box .admin-message,\n  .chat-box .sms-box .user-message {\n    background: var(--dark-primary-hover);\n    color: var(--light-text);\n\n    .time {\n      color: var(--dark-muted-text);\n    }\n  }\n\n  .chat-box .chat-date {\n    background: var(--dark-grey);\n\n    &::after {\n      background: var(--dark-grey);\n      color: var(--light-text);\n    }\n  }\n}\n\n.cs-message__content {\n  background: transparent !important;\n  padding: 0 !important;\n  .cs-message__image-content {\n    padding: 15px !important;\n  }\n}\n\n.message-actions {\n  &-wrapper {\n    background-color: var(--white);\n    position: sticky;\n    display: flex;\n    bottom: 0;\n    padding-left: 1rem;\n    box-shadow: 0 10px 0 0 var(--background);\n    -webkit-box-shadow: 0 10px 0 0 var(--background);\n    -moz-box-shadow: 0 10px 0 0 var(--background);\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      display: block;\n      background: var(--primary);\n      height: 100%;\n      width: 2px;\n      left: 0;\n    }\n  }\n\n  &__content {\n    flex-grow: 1;\n    width: 90%;\n  }\n\n  &__type {\n    font-size: 13px;\n    text-transform: capitalize;\n  }\n\n  &__message {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-bottom: 0;\n  }\n\n  &__close-btn {\n    background: transparent;\n    border: none;\n    outline: none;\n    cursor: pointer;\n  }\n\n  &__image {\n    max-width: 90%;\n    height: 4rem;\n    display: block;\n  }\n}\n\n[data-theme='dark'] .message-actions {\n  &-wrapper {\n    background-color: var(--dark-background);\n    color: var(--light-text);\n    box-shadow: 0 10px 0 0 var(--dark-background);\n    -webkit-box-shadow: 0 10px 0 0 var(--dark-background);\n    -moz-box-shadow: 0 10px 0 0 var(--dark-background);\n  }\n}\n\n.reply-message {\n  position: relative;\n  padding-left: .5rem;\n  margin-bottom: .5rem;\n\n  &::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    height: 100%;\n    width: 2px;\n    background: var(--primary);\n    top: 0;\n    left: 0;\n  }\n\n  &__text {\n    font-size: 12px;\n    line-height: 1rem;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__image {\n    display: block;\n    max-height: 3rem;\n    max-width: 100%;\n  }\n}\n\n.upload-form {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  img {\n    width: 100%;\n    max-height: 270px;\n    object-fit: contain;\n  }\n\n  textarea {\n    margin-top: 20px;\n  }\n\n  .footer-btns {\n    padding-top: 20px;\n    width: 100%;\n    gap: 8px;\n    display: flex;\n    justify-content: flex-end;\n\n    // button {\n    //   // background: transparent;\n    //   // color: var(--grey);\n    //   // border: none;\n\n    //   &:hover {\n    //     background: rgba($color: #000, $alpha: 0.1);\n    //   }\n    // }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
